import { render, staticRenderFns } from "./QuestionTypeFreeTextVideo.vue?vue&type=template&id=324d53c6"
import script from "./QuestionTypeFreeTextVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFreeTextVideo.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeFreeTextVideo.vue?vue&type=style&index=0&id=324d53c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports